var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo16 = function SvgInfo16(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06639 3C8.81878 3 8.58131 3.08887 8.40622 3.24706C8.23114 3.40525 8.13277 3.6198 8.13277 3.84352C8.13277 4.06723 8.23114 4.28179 8.40622 4.43998C8.58131 4.59817 8.81878 4.68704 9.06639 4.68704C9.314 4.68704 9.55146 4.59817 9.72655 4.43998C9.90164 4.28179 10 4.06723 10 3.84352C10 3.6198 9.90164 3.40525 9.72655 3.24706C9.55146 3.08887 9.314 3 9.06639 3ZM8.84232 5.68239C8.10165 5.73863 6.07882 7.1951 6.07882 7.1951C5.95434 7.27946 5.99168 7.27383 6.09127 7.43129C6.19086 7.58312 6.17841 7.59437 6.29667 7.52127C6.42115 7.44816 6.62654 7.33007 6.96887 7.13887C8.28837 6.37408 7.18049 8.13985 6.61409 11.1147C6.39003 12.588 7.85891 11.8288 8.23858 11.6039C8.61203 11.3846 9.61411 10.7604 9.71369 10.6985C9.85062 10.6142 9.75104 10.5467 9.64523 10.4061C9.57054 10.3105 9.49585 10.378 9.49585 10.378C9.09128 10.6198 8.35062 11.1259 8.25103 10.8054C8.13277 10.4848 8.89211 8.28606 9.30913 6.77334C9.37759 6.41344 9.56431 5.62616 8.84232 5.68239Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo16);
export default ForwardRef;